var map = {
	"./dish-1.png": 7189,
	"./dish-2.png": 3207,
	"./dish-3.png": 3314,
	"./dish-4.png": 4234,
	"./dish-5.png": 4920,
	"./dish-6.png": 8351,
	"./dish-7.png": 5108,
	"./dish-8.png": 3395
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3120;